module.exports = __webpack_public_path__ + "static/img/mobil-menu.955bfca9.svg";